import React, { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import * as S from './styles'

import { useGeneral } from '../../contexts/GeneralContext'

import Header from '../../components/Header'
import Footer from '../LandingPages/Components/Footer'
import Input, { InputArea } from '../../components/Input'
import Upload, { UploadAreaMethods } from '../../components/Upload'

import {
  createPublicComplaint,
  CreatePublicComplaintRequest
} from '../../lib/public-complaint'

const PublicComplaint: React.FC = () => {
  const { setIsLoading, apiHandler } = useGeneral()
  const [data, setData] = useState<CreatePublicComplaintRequest>(
    {} as CreatePublicComplaintRequest
  )
  const uploadFilesRef = useRef<UploadAreaMethods>(null)

  const navigate = useNavigate()

  const handleCreatePublicComplaint = async () => {
    return apiHandler({
      apiCaller: createPublicComplaint,
      constructData: async () => {
        const uploadedCover = await uploadFilesRef.current?.handleSave()

        return [
          {
            ...data,
            files: uploadedCover?.newFiles,
            name: !data.name ? null : data.name,
            email: !data.email ? null : data.email,
            document: !data.document ? null : data.document
          }
        ]
      },
      setIsLoading,
      onSuccess: () => {
        navigate('/')

        return 'Denúncia realizada com sucesso, agradecemos por sua colaboração e compromisso com a integridade!'
      }
    })
  }

  return (
    <S.Container>
      <Header dark />

      <S.GeneralContainer>
        <S.Card>
          <S.Column>
            <nav>
              <h4>Formulário</h4>
              <p>
                Use o formulário abaixo para relatar casos de irregularidades,
                como fraudes, assédio, discriminação, problemas de segurança da
                informação, falsificação de dados, riscos à saúde no trabalho,
                atitudes antiéticas ou questões ambientais relacionadas à
                empresa.
              </p>
            </nav>
            <Input
              label="Assunto"
              placeholder="Insira o assunto..."
              value={data.title}
              onChange={(e: any) => {
                const value = e.target.value
                setData(prev => ({
                  ...prev,
                  title: value
                }))
              }}
            />
            <InputArea
              label="Descrição"
              placeholder="Insira sua descrição..."
              value={data.description}
              onChange={(e: any) => {
                const value = e.target.value
                setData(prev => ({
                  ...prev,
                  description: value
                }))
              }}
            />

            <Input
              label="Seu nome (opcional)"
              placeholder="Insira seu nome..."
              value={data.name || ''}
              onChange={(e: any) => {
                const value = e.target.value
                setData(prev => ({
                  ...prev,
                  name: value
                }))
              }}
            />
            <Input
              label="Seu e-mail (opcional)"
              placeholder="Insira seu e-mail..."
              value={data.email || ''}
              onChange={(e: any) => {
                const value = e.target.value
                setData(prev => ({
                  ...prev,
                  email: value
                }))
              }}
            />
            <Input
              label="Seu documento (opcional)"
              placeholder="Insira seu documento..."
              value={data.document || ''}
              onChange={(e: any) => {
                const value = e.target.value
                setData(prev => ({
                  ...prev,
                  document: value
                }))
              }}
            />

            <Upload
              ref={uploadFilesRef}
              props={{
                title: 'Arquivos',
                label: 'Anexe arquivos para complementar a denúncia',
                type: 'mix',
                maxQuantity: 5,
                maxSize: 100
              }}
              callback={() => {
                const newFiles = uploadFilesRef.current?.getNewFiles() || []

                if (newFiles.length > 0) {
                  setData(prev => ({
                    ...prev,
                    files: newFiles.map(item => item.preview)
                  }))
                }
              }}
            />

            <S.ButtonContainer>
              <button
                onClick={handleCreatePublicComplaint}
                disabled={!data.title || !data.description}
              >
                Enviar
              </button>
            </S.ButtonContainer>
          </S.Column>
        </S.Card>
      </S.GeneralContainer>

      <Footer />
    </S.Container>
  )
}

export default PublicComplaint
